import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ImgsCollection } from '../interfaces/images/imgs-collection.interface';
import { IconsCollection } from '../interfaces/icons/icons-collection.interface';

@Injectable({
  providedIn: 'root'
})
export class PathsDataService {
  private pathJSON: string = 'assets/data/paths.json';


  constructor(private http: HttpClient) { }


  getPathImgs(): Observable<ImgsCollection> {
    return this.http.get<{images:ImgsCollection}>(this.pathJSON).pipe(
      map(response => {
        return response.images;
      })
    );
  }

  getPathIcons(): Observable<IconsCollection> {
    return this.http.get<{icons:IconsCollection}>(this.pathJSON).pipe(
      map(response => {
        return response.icons;
      })
    );
  }
}
